import { updatePricingVehicleOrderRequest } from "../../data/pricingVehicleApi";

export async function updatePricingVehicleOrderUseCase(vehicles) {
  const payload = vehicles.map((vehicle, index) => ({
    id: Number(vehicle.id),
    order: index + 1,
  }));

  return await updatePricingVehicleOrderRequest(payload);
}
